module.exports = "<div class=\"\">\n  <div class=\"image-cropper\" [ngClass]=\"{'border-red': errorMsg}\">\n    <app-image-cropper #imageCropper [imageCropperOptions]=\"{id:prop.id}\" (flagImgUpload)=\"uploadValidImage($event)\"></app-image-cropper>\n  </div>\n  <div class=\"col-form-label fs13 text-danger\">{{errorMsg}}</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/modal-cropper/modal-cropper.component.html
// module id = ../../../../../src/app/components/modal-cropper/modal-cropper.component.html
// module chunks = main